module.exports = __webpack_public_path__ + "img/header-weddingRingsPolar.3a12e4d.webp";